import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { Units, Colors, hexToRgba } from 'Css';

const css = oxygenCss({
  root: {
    padding: `0 ${Units.base}px`,
    lineHeight: `${40}px`,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: `${hexToRgba(Colors.material.coursio[300].hex, 5)}`
    },
    '&selected': {
      backgroundColor: `${hexToRgba(Colors.material.coursio[300].hex, 25)}`
    }
  }
});

class Option extends Component {
  static propTypes = {
    onTouchTap: PropTypes.func,
    children: PropTypes.node,
    selected: PropTypes.bool,
    payload: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.object
    ])
  };

  handleTap = event => {
    const { payload, onTouchTap } = this.props;
    onTouchTap && onTouchTap(payload);
    event.stopPropagation();
    event.preventDefault();
  };

  render() {
    const { children, payload, onTouchTap, selected, ...other } = this.props;
    const classes = classNames(css.root, {
      [css.selected]: selected
    });
    return (
      <div {...other} onTouchTap={this.handleTap} className={classes}>
        {children}
      </div>
    );
  }
}

export default Option;



// WEBPACK FOOTER //
// ./src/js/components/DropDown/Option.js